import { AuthenticationManager } from "@core/managers/authentication.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { EtabSignupService } from "@core/services";
import { ISignup } from "@core/models";
import { ETAB_EVENTS, ETAB_ROUTES } from "@etab/config";
import { EventManager } from "@core/managers/event.manager";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { LoadingManager } from "@core/managers/loading.manager";

export function useSignup() {
  const loading = ref(false);
  const router = useRouter();

  const $_nextStep = function ({ step } = {}) {
    EventManager.emit(ETAB_EVENTS.STEPS.NEXT_STEP, { step });
  };
  const $_completeCreationProcess = async function ({ signupData }) {
    try {
      LoadingManager.show();
      await EtabSignupService.create({ signupData });

      const login = signupData[ISignup.email];
      const password = signupData[ISignup.password];
      await $_autoLogin({ login, password });
    } catch (error) {
      NotificationsManager.contactEtabSupport();
      throw error;
    } finally {
      LoadingManager.hide();
    }
  };
  const $_autoLogin = async function ({ login, password }) {
    const loginSuccess = await AuthenticationManager.login({ login, password });
    if (loginSuccess) {
      $_navigateToCreationSuccessPage();
    } else {
      // RG Signup: there's a problem with auth, we ask the user to log himself in a nice way
      NotificationsManager.success({ message: "ERRORS.@ACCOUNT_CREATED_PLEASE_LOGIN" });
      $_navigateToLoginPage();
    }
  };
  const $_navigateToCreationSuccessPage = function () {
    router.push({ name: ETAB_ROUTES.signup.steps.root.name, params: { success: true } });
  };
  const $_navigateToLoginPage = function () {
    router.push({ name: ETAB_ROUTES.auth.login.name });
  };
  return {
    loading,
    $_nextStep,
    $_completeCreationProcess,
    $_autoLogin,
    $_navigateToCreationSuccessPage,
  };
}
